<template>
  <section class="atom-grid row">
    <div class="edit" v-if="edit">
      <el-button-group>
        <div class="edit-atom">
          <div>
            <el-button v-if="column > 1" @click="column -= 1"><i class="material-icons">remove_circle</i></el-button>
            <el-button @click="column += 1"><i class="material-icons">add_circle</i></el-button>
            <span>
              {{ column}} x
              <i class="material-icons">dashboard</i>
              &nbsp;
            </span>
            <el-button @click="$emit('meta')"><i class="material-icons">extension</i></el-button>
          </div>
        </div>
      </el-button-group>
    </div>

    <div v-for="(c, index) in value.columns" :key="index" class="col">
      <input-rich-text v-if="c.atoms" v-model="c.atoms" :key="`GridCoreEditor${unique}${c.id}`"></input-rich-text>
      <span class="number">{{ index + 1 }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AtomGrid',
  props: ['value', 'edit'],
  components: {
    InputRichText: () => import('../InputRichText.vue'),
  },
  data() {
    return {
      unique: Math.floor(Math.random() * Math.floor(100000)),
      column: 2,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    column: 'updateColumn',
  },
  methods: {
    init() {
      this.$set(this.value, 'style', this.value.style || {});
      this.$set(this.value, 'meta', this.value.meta || []);
      this.$set(this.value, 'columns', this.value.columns || []);
      this.column = this.value.columns.length || 2;
      this.updateColumn();
    },
    updateColumn() {
      const columns = [];
      for (let index = 0; index < this.column; index += 1) {
        columns[index] = this.value.columns[index] || {
          id: Math.floor(Math.random() * Math.floor(100000)),
          atoms: [],
        };

        if (columns[index].atoms.length === 0) {
          columns[index].atoms.push({ id: Math.floor(Math.random() * Math.floor(100000)), type: 'AtomText', props: {} });
        }
      }

      this.$set(this.value, 'columns', columns);
    },
  },
};
</script>

<style lang="sass">
.atom-grid.row
  display: flex
  flex-direction: row
  flex-wrap: wrap
  justify-content: space-between
  align-items: stretch
  padding: 1rem
  > div
    position: relative

  .col
    margin: 0 0.5rem 1rem 0
    flex: 1 0 48%
    border-left: 2px dashed lighten(#ff3c48, 20%)
    .number
      position: absolute
      display: flex
      align-items: center
      justify-content: center
      top: 0
      left: -2px
      width: 20px
      height: 20px
      background: lighten(#ff3c48, 20%)
      color: white
      font-size: 0.7rem
      font-weight: bold
      border-radius: 0 2px 60% 0

</style>
